import { render } from "./_modal.vue?vue&type=template&id=b7c2218a&lang=pug"
import script from "./_modal.vue?vue&type=script&lang=js"
export * from "./_modal.vue?vue&type=script&lang=js"

import "./_modal.vue?vue&type=style&index=0&id=b7c2218a&lang=sass"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__